export function openPage(href: string): void {
  const save = document.createElement('a');
  save.href = href;
  const evt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false,
  });
  save.dispatchEvent(evt);
}

export function reloadPageSkipBrowserCache(): void {
  location.reload();
}
